import clsx from "clsx";
import { styled } from "@mui/material";
import CardContent from "./CardSectionContent";
import CardSection from "./CardSection";
import CardTitle from "./CardSectionTitle";

const ContainerStyled = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  border: "1px solid #0000001f",
  borderRadius: theme.spacing(1),
  overflow: "hidden",
  backgroundColor: "#ffffff",
}));

const CardUnstyled = ({ children, className }) => (
  <ContainerStyled className={clsx("card", className)}>
    {children}
  </ContainerStyled>
);

const Card = styled(CardUnstyled)({});

export default Card;

Card.Section = CardSection;
Card.SectionTitle = CardTitle;
Card.SectionContent = CardContent;
